import './content.css'
import Contentheader from './Contentheader';
import { useState } from "react";
import Modal from './Modal';


function Calc(){

   const Features=()=>{
      const element = document.getElementById("users");
      element.scrollIntoView();
   }
   const Feat=()=>{
    const element = document.getElementById("feat");
    element.scrollIntoView();
 }


 const[popup,setpopup]= useState(false);




return(<div>
       {popup && <Modal setpopup={setpopup} myurl={'https://www.youtube.com/watch?v=MAv5iOP1f5k'} />}
<Contentheader/>

<div className='row main '>
<div className='col-3'></div>
  <div className='col-md-6'>
  <div className='searchbox'>

    <h2 id='headingcontent'>Estimate Event Cost (Calculator) </h2>
 <h4 className='stepcontent'>Learn how to Estimate your Event Cost </h4>

</div>


<pre></pre>
  </div>

</div>
<br></br><br></br>
<div className='  container-sm'>
   <div className='row'>
<div className='col-md-3 '>
   <div className=' categoriescont p-3 ' id='index'>
  <div className='categories'>Table of Contents</div>
  <div className='contentcategories' onClick={Features}>Calculator</div> 
  <div className='contentcategories' onClick={Feat}>Features</div> 
 
  </div>
</div>
<div className='col-md-9 descripton'>
   <div className='p-3'>
<h3 >Calculator</h3>
<p className='lines'  id='users'>
Subscription module provides an easy to use calculation chart for events .It calculates the cost based on features needed for an event for a certain subscription plan.Subscription module provides a pricing plan chart .All the calculations are based on the plans given in it.
<br></br><p style={{ fontWeight: '600' }}>[ Note:Refer the pricing plan page for further pricing details .]</p>



</p>

<li className='lines_' id='Customize'>To estimate event cost subscriber should first :

<ul className='lines'>
<li className='lines'>Select  the  month
          </li>
<li className='lines'> Select  a subscription : Whether Free/Express/Premium    </li>
</ul></li>

<p className='lines'>
There will be prices already defined based on event subscription plan.If the user wants more features he opts for add-ons and purchased more products.To have an estimate of the total amount costing him,he can input the following features :

</p>


<p id='feat' className='lines' style={{ fontWeight: '600' }}>
Number of events to be hosted.<br></br>
Total Attendees ;499<br></br>
Total Booth :10<br></br>
Total Exhibition Hall:3<br></br>
Total Networking Area :2<br></br>
Custom Full Suit Templates 0<br></br>
Custom Landing Template 0<br></br>
Custom Lobby Template 0<br></br>
Custom Auditorium Template 0<br></br>
Custom Exhibiton Hall Template 0<br></br>
Custom Booth Template 0<br></br>
Custom Networking Template 0<br></br>
Branded Walktrough 0<br></br>
Chat 0<br></br>
Video Chat 0<br></br>
Private Live Player For 4 Hour 0<br></br>
Private Live Player For 8 Hour 0<br></br>
Production Support Per Hour 0<br></br>
Traffic Car Racer Game with Leaderboard 0<br></br>
One Time White-label URL For a Full Year 0<br></br>
One Event White-label URL<br></br>

</p>

<br></br>
<div className='text-center'>
<button onClick={()=>{setpopup(true)}} className=' vbu '>Watch Video</button>

</div>
</div>
</div>



   </div>

</div>
</div>)



}

export default Calc;